// extracted by mini-css-extract-plugin
export default {"login-form-wrap":"Login_login-form-wrap__iwIqV","login-form":"Login_login-form__GmyAL","logo":"Login_logo__jkQZH","error":"Login_error__WqNYD","form-text":"Login_form-text__cNPQl"};